import { render, staticRenderFns } from "./distributionForm.vue?vue&type=template&id=01ad9b84"
import script from "./distributionForm.vue?vue&type=script&lang=js"
export * from "./distributionForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports